import {ParticipantMember} from './ParticipantMember';
import {EntryDay} from './EntryDay';

export class Calendar {
    name: string;
    days: EntryDay[];
    participants: ParticipantMember[];

    constructor() {

    }
}
